import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_store_management-account_settings_stores_link-click';

/**
 * Event that gets fired when the user clicks the "Stores" link leading to the Stores page in the account settings.
 */
export function trackRetailerStoreManagementAccountSettingsStoresLinkClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
  });
}
